import { defineStyleConfig } from "@chakra-ui/react";

const Link = defineStyleConfig({
  // The styles all button have in common
  baseStyle: {
    // color: "gray.900",
    fontWeight: "var(--chakra-fontWeights-bold)",
  },
});

export default Link;
